function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import VerticalTabsDefaultProps from "segments/desktop/core-components/vertical-tabs/default-props";
import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";
import { LG } from "constants/sizes";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "/styles/colors";
export default _object_spread_props(_object_spread({}, VerticalTabsDefaultProps), {
    backgroundColor: "light-blue-video-background",
    paddingTop: 0,
    paddingBottom: 0,
    titleSize: LG,
    tabsPosition: positionTypes.TOP_LEFT,
    minHeight: 500,
    addTimeline: true,
    addTabIndicator: false,
    fullBackground: true,
    lineColor: Colors[WHITE_COLOR_NAME]
});
